import { useContext } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { initializeAdCustomizer } from '@bingads-webui-campaign/ad-customizers-next';
import config from '@bingads-webui-component-legacy/config/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';

export const useInitAdCustomizer = ({ viewContext, permissions, i18n }) => {
  const instrumentation = useContext(InstrumentationContext);
  const campaignId = viewContext.currentCampaign && viewContext.currentCampaign.Id;
  const adGroupId = viewContext.currentAdGroup && viewContext.currentAdGroup.Id;

  initializeAdCustomizer({
    deps: {
      i18n,
      config,
      instrumentation,
      permissions,
      edmCampaign,
      jsDataCampaign,
      timeZone: config.get('AccountTimeZone'),
      scope: {
        campaignId: Number(campaignId),
        adGroupId: Number(adGroupId),
      },
      showAdCustomizers: true,
      IsRSAIffPopupEnabledFromDeps: false,
    },
    adType: 'ResponsiveAd',
  });
};
